<template>
  <div class="p-2 text-left">
    <div class="row">
      <div class="col-12 mb-2">
        <b-input-group>
          <b-form-input
            v-model="search_text"
            placeholder="Search focus log..."
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              class="m-0"
              @click="feelingsGet('search')"
            >
              <i class="fas fa-search"></i>
            </b-button>
            <b-button
              variant="outline-secondary"
              class="m-0"
              @click="feelingsGet('latest')"
            >
              <div v-if="history.length === 0" class="text-muted">
                <i class="fas fa-redo"></i>
              </div>
              <span v-else>
                <i class="fas fa-times"></i>
              </span>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>

      <div v-if="readonly == 0" class="col-12 mb-3">
        <b-button block @click="addFeelings">
          <i class="fas fa-plus"></i> Daily log
        </b-button>

        <!-- <b-dropdown block right split>
					<template #button-content>
						<span block variant="outline-primary" @click="addFeelings">
							<i class="fas fa-pen"></i> Set My Intentions
						</span>
					</template>

					<b-dropdown-item @click="shareData">
						<i class="fas fa-share"></i> Share My Data
					</b-dropdown-item>
				</b-dropdown> -->
      </div>
    </div>

    <div v-if="searching == 1" class="text-muted text-center">
      <i class="fas fa-atom fa-spin"></i> searching
    </div>

    <div v-if="history !== null && history.length > 0" class="text-left">
      <div
        class="pointer mb-1"
        v-for="(feeling, index) in history"
        :key="'feeling-' + index"
        @click="viewFeeling(feeling)"
      >
        <div v-if="feeling.data.bars">
          <div class="row">
            <div class="col-12 gold small">
              <i
                v-if="feeling.has_new_comment == 1"
                class="fas fa-comment-dots fa-flip-horizontal fa-2x mr-2 text-danger"
              ></i>
              <span class="" v-text="feeling.date_human"> </span>
            </div>

            <div class="col-12">
              <div class="progress" style="height: 20px">
                <div
                  v-for="(value, id) in feeling.data.bars"
                  :key="'progress-' + id"
                  class="progress-bar border-bottom text-left border-right"
                  role="progressbar"
                  :aria-valuenow="value"
                  aria-valuemin="0"
                  aria-valuemax="10"
                  :style="setBarWidth(value, id, feeling.data.bars)"
                  :class="setBarColour(value)"
                >
                  <span v-if="value > 0" class="text-white pl-1">
                    <small v-text="id" class="pr-1"></small>
                    <b v-text="value"></b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Focus Log Modal -->
    <b-modal id="feelings_wrapper" title="Daily Log" size="lg">
      <div>
        <!-- Date_selected -->
        <div class="row mb-2">
          <div class="col-12">
            <b-form-datepicker
              v-if="readonly == 0"
              v-model="date_selected"
              class="w-100"
              size="lg"
              :max="date_max"
              @change="saveToLocalStorage"
            >
            </b-form-datepicker>
            <div v-else>Date: <b v-text="active_feeling.date_human"></b></div>

            <p
              v-if="message.text.length > 0"
              :class="message.class"
              class="p-2"
            >
              <i :class="message.icon" class="pr-1"></i>
              <span v-text="message.text"></span>
            </p>
          </div>
        </div>

        <!-- If allow edit -->
        <div v-if="readonly == 1">
          <div v-if="active_feeling.data && active_feeling.data.bars">
            <div
              v-for="item in Object.entries(active_feeling.data.bars)"
              :key="item[0]"
              class=""
            >
              <div v-if="item[1] && item[1] > 0" class="row">
                <div class="col mb-1">
                  <b-progress max="10" height="1.75rem">
                    <b-progress-bar
                      :value="item[1]"
                      :variant="setColour2(item[1])"
                    >
                      <div class="text-left pl-2">
                        <span v-text="item[0]" class=""></span>
                      </div>
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </div>
          </div>

          <div v-for="item in questions" :key="item.id">
            <div
              v-if="
                item.value != '' &&
                  typeof item.value !== 'undefined' &&
                  item.id !== 'comments'
              "
            >
              <div
                v-if="$route.name === 'sample_data' && item.id == 'goal'"
              ></div>
              <div v-else>
                <p class="mb-2"><b v-text="item.title"></b>:</p>
                <div
                  v-html="item.sanitised_value"
                  class="mb-2 pb-2 border-bottom pre-formatted"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <b-list-group>
            <b-list-group-item
              v-for="item in feelings"
              :key="item.id"
              :class="setColour(item.id)"
            >
              <label class="pre-formatted">
                <b v-text="item.title"></b>:
                <small v-text="item.description"></small>
              </label>
              <b-row align-v="center">
                <div class="col-10">
                  <input
                    v-if="!item.type || item.type !== 'text'"
                    type="range"
                    v-model="item.value"
                    class="form-range w-100"
                    min="0"
                    :max="item.max"
                    step="1"
                    @change="validateForm()"
                  />
                </div>
                <div class="col-2 text-center text-white">
                  <h1
                    v-if="item.id != 'overwhelm' && item.id != 'fatigue'"
                    v-text="item.value"
                  ></h1>
                  <h3 v-else v-text="yesNoText(item.value)"></h3>
                </div>
              </b-row>
            </b-list-group-item>

            <!-- questions inputs -->
            <b-list-group-item v-for="item in questions" :key="item.id">
              <hr v-if="item.id == 'goal'" />

              <!-- Edit modals -->
              <div v-if="modal_type == 'edit'">
                <div v-if="item.id !== 'comments'">
                  <label
                    :class="{ 'gold h5': item.id == 'goal' }"
                    class="pre-formatted"
                  >
                    <span v-if="item.description === ''">
                      <b v-text="item.title"></b>:<br />
                      <small class="" v-text="item.subtitle"></small>
                    </span>
                    <a
                      v-else
                      v-b-toggle
                      :href="'#hint-' + item.id"
                      @click.prevent
                      class="text-secondary"
                    >
                      <i class="fas fa-question-circle pr-2 gold"></i>

                      <b v-text="item.title"></b>:<br />
                      <small class="pl-4" v-text="item.subtitle"></small>
                    </a>
                  </label>
                  <b-collapse
                    v-if="item.description !== ''"
                    :id="'hint-' + item.id"
                  >
                    <p
                      v-text="item.description"
                      class="small bronze pre-formatted"
                    ></p>
                  </b-collapse>

                  <b-form-textarea
                    v-if="!item.type || item.type !== 'text'"
                    v-model="item.sanitised_value"
                    :placeholder="item.placeholder"
                    rows="2"
                    max-rows="30"
                    class="mb-2"
                    @change="validateForm()"
                  ></b-form-textarea>
                </div>
              </div>

              <!-- Add modal types -->
              <div v-else>
                <div v-if="item.id !== 'challenge'">
                  <div class=""></div>

                  <label
                    :class="{ 'gold h5': item.id == 'goal' }"
                    class="pre-formatted"
                  >
                    <span v-if="item.description === ''">
                      <b v-text="item.title"></b>:<br />
                      <small class="" v-text="item.subtitle"></small>
                    </span>
                    <a
                      v-else
                      v-b-toggle
                      :href="'#hint-' + item.id"
                      @click.prevent
                      class="text-secondary"
                    >
                      <i class="fas fa-question-circle pr-2 gold"></i>

                      <b v-text="item.title"></b>:<br />
                      <small class="pl-4" v-text="item.subtitle"></small>
                    </a>
                  </label>
                  <b-collapse
                    v-if="item.description !== ''"
                    :id="'hint-' + item.id"
                  >
                    <p
                      v-text="item.description"
                      class="small bronze pre-formatted"
                    ></p>
                  </b-collapse>
                  <b-form-textarea
                    v-if="!item.type || item.type !== 'text'"
                    v-model="item.sanitised_value"
                    :placeholder="item.placeholder"
                    rows="2"
                    max-rows="30"
                    class="mb-2"
                    @change="saveToLocalStorage"
                  ></b-form-textarea>
                </div>
              </div>
            </b-list-group-item>

            <b-list-group-item>
              <div class="">
                <p v-text="message.text" :class="message.class"></p>

                <button
                  type="button"
                  class="btn btn-primary"
                  @click="submit"
                  :disabled="!can_submit"
                >
                  <i class="fas fa-cloud-sun-rain fa-1x mr-1"></i>
                  <span v-if="modal_type == 'add'">Log</span
                  ><span v-else>Edit</span> my focus
                </button>

                <b-button
                  v-if="modal_type === 'edit'"
                  size="sm"
                  variant="outline-danger"
                  @click="removeFeeling"
                >
                  <i class="fas fa-trash-alt"></i> Delete
                </b-button>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>

        <div v-if="active_feeling.replies" class="col-12 pt-2 mt-2 mb-4">
          <h4 class="border-bottom pb-2 pt-2 gold">Comments</h4>

          <div
            v-for="R in active_feeling.replies"
            :key="R.id"
            :class="'R_' + R.id"
            class="mb-4 pb-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-12">
                <p class="small text-right">
                  <i class="fas fa-user pr-1"></i>
                  <span v-text="R.user_name"></span><br />
                  <i class="far fa-clock pr-1"></i>
                  <span v-text="R.access.date"></span> -
                  <span v-text="R.access.time" class=""></span>
                </p>
                <div>
                  <span v-html="R.main_text" class="pre-formatted"></span>
                </div>
              </div>
            </div>

            <div
              v-if="
                (R.youtube && R.youtube.length > 0) ||
                  (R.vimeo && R.vimeo.length > 0)
              "
              class=""
            >
              <video-embeds :embeddata="R" classW="col-md-6 mb-2" />
            </div>
          </div>
        </div>

        <div v-if="this.modal_type == 'edit'" class="col-12 mb-2 mt-2">
          <p class="p-0 m-0 mt-3">
            <b>Comments / Notes</b>
            <small
              v-if="modal_type == 'add'"
              v-text="questions.comments.description"
            ></small>
          </p>
          <b-form-textarea
            v-model="reply_text"
            placeholder="Add any notes here"
            rows="6"
            max-rows="30"
            class="mt-2"
            @change="saveToLocalStorage"
          ></b-form-textarea>
          <b-button size="sm" variant="primary" @click="replyAdd()">
            Add Comment
          </b-button>
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <div>
          <b-button size="sm" variant="outline-secondary" @click="cancel()">
            Close
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- <b-modal id="share_wrapper" title="Select my data" size="md" no-close-on-backdrop>
			<b-form-group>
				<small class="text-muted">Select who to share with</small>
				<v-select
					:options="share_members"
					:filterable="false"
					:multiple="true"
					@search="membersSearch"
					v-model="share_members_selected"
				>
					<template slot="no-options"> Search and select the team leader </template>

					<template slot="option" slot-scope="option">
						<div class="d-center">
							{{ option.label }}
						</div>
					</template>

					<template slot="selected-option" slot-scope="option">
						<div class="selected d-center">
							{{ option.label }}
						</div>
					</template>
				</v-select>

				<small class="text-danger m-2" v-if="share_members_selected === null">
					No members selected...
				</small>
			</b-form-group>

			<template #modal-footer="{ ok, cancel }">
				<div>
					<b-button size="sm" variant="outline-secondary" @click="cancel()"> Cancel </b-button>

					<b-button size="md" variant="primary" @click="ok()"> Save</b-button>
				</div>
			</template>
		</b-modal> -->
  </div>
</template>

<script>
import axios from "axios";
import VideoEmbeds from "../components/VideoEmbeds.vue";
import EventBus from "@/bus";
/*import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';*/

export default {
  name: "FeelingsLog",
  components: {
    VideoEmbeds,
  },
  props: {
    userid: {
      type: Number,
      default: null,
    },
    limit: {
      type: Number,
      default: 14,
    },
    readonly: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      active_feeling: {},
      addUserGoalMsg: "",

      date_max: new Date(),
      date_selected: this.date,
      can_submit: true,
      modal_type: "add",
      search_text: "",
      searching: 1,

      reply_text: "",

      max_progress: 30,
      opened_add_modal: false,
      message: {
        text: "Select a date above",
        class: "text-danger",
        icon: "fas fa-times",
      },
      history: [],

      /*share_members_selected: null,
			share_members: [],*/

      feelings_total: 0,
      feelings: {
        productivity: {
          id: "productivity",
          title: "Productivity",
          description: "How productive were you yesterday?",
          value: 0,
          max: 10,
        },
        wellbeing: {
          id: "wellbeing",
          title: "Wellbeing",
          description: "How is your general sense of wellbeing today?",
          value: 0,
          max: 10,
        },
      },
      goal: "",
      goal_latest: "",
      questions: {
        goal: {
          id: "goal",
          title: "Current Goal",
          subtitle:
            "What is the number one goal you are working on, that if you achieved your goal it would positively change everything for you?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Typically filled out and only changed once completed",
        },
        actions: {
          id: "actions",
          title: "Actions",
          subtitle:
            "What actions are you going to take today towards your goal?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        habits_text: {
          id: "habits_text",
          type: "text",
          title: "When you think about the person you want to be",
          subtitle: "What habits do they have?",
          description:
            "Habits are actions that you take consistently. \nMoving through 4 phases of growth \n\nUNCONSCIOUS INCOMPETENCE. We don't know that we don't know. ...\nCONSCIOUS INCOMPETENCE. We know that we don't know. ... \nCONSCIOUS COMPETENCE. We work at what we don't know. ... \nUNCONSCIOUS COMPETENCE. We don't have to think about knowing it.",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },
        habits_a: {
          id: "habits_a",
          title: "Habit a",
          subtitle:
            "What habits do you wish to nurture and how did you nurture them yesterday through daily actions?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },
        habits_b: {
          id: "habits_b",
          title: "Habit b",
          subtitle:
            "What habits would you like to let go of? ie: those that do not serve your potential. What did you do yesterday that reinforced a negative habit and what are you going to choose differently today?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        contractions: {
          id: "contractions",
          title: "Contractions",
          subtitle:
            "As you go about your day, become aware of your contractions and list those you recall from the previous day.",
          description:
            "Often that which is holding us back is unconscious to us. When we contract during the day often this is pointing to a wound (if you are human, you have them) inside that if it were healed you would have access to more of your potential. These wounds create limitations. As you go about your day, become aware of your contractions and list those you recall from the previous day. Contractions show up as a sudden rush of negative emotion or where your world gets small or where a thought or pattern of thinking is negatively triggered and takes over.",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        beliefs: {
          id: "beliefs",
          title: "Beliefs",
          subtitle:
            "To be the person you want to be, what do you need to believe about yourself? Be specific",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        grateful: {
          id: "grateful",
          title: "Gratitude",
          subtitle: "What are 3 things you're grateful for?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        forgive: {
          id: "forgive",
          title: "Forgiveness",
          subtitle:
            "What do you need to forgive yourself for? Who else do you need to forgive?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        help: {
          id: "help",
          title: "Help Needed",
          subtitle: "What do you need help with?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        win: {
          id: "win",
          title: "Biggest Win",
          subtitle: "What was your biggest win yesterday?",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "Ideally Daily",
        },

        comments: {
          id: "comments",
          title: "Comments",
          subtitle:
            "Any additional information/requests/comments for your iAMconnected coach.",
          description: "",
          value: "",
          sanitised_value: "",
          placeholder: "As needed",
        },
      },
    };
  },
  created() {
    EventBus.$on('showDailyLogPopup', this.addFeelings)
  },
  beforeMount() {
    this.sanitiseQuestions();
  },
  mounted() {
    this.date_selected = this.date;
    this.feelingsGet("latest");
  },
  beforeDestroy() {
    EventBus.$off('showDailyLogPopup', this.addFeelings)
  },
  computed: {
    date: {
      get: function() {
        /*
					toISOString returns a string in simplified extended ISO format (ISO 8601), which is always 24 or 27 characters long ( YYYY - MM - DD T HH : mm : ss. sss Z or ± YYYYYY - MM - DD T HH : mm : ss. sss Z , respectively). The timezone is always zero UTC offset, as denoted by the suffix " Z ".
				*/
        return new Date().toISOString().slice(0, 10);
      },
      set: function(val) {
        this.date_selected = val;
      },
    },
  },
  methods: {
    sanitiseQuestions: function() {
      console.log(this.questions);
      for (let key in this.questions) {
        try {
          let obj = JSON.parse(this.questions[key]["value"]);
          this.questions[key]["sanitised_value"] = obj["text"];
        } catch (error) {
          this.questions[key]["sanitised_value"] = this.questions[key]["value"];
        }
      }
    },
    /* temp */
    addUserGoal() {
      console.log("addUserGoal:" + this.goal);
      let _this = this;

      _this.addUserGoalMsg = "Processing...";

      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("goal", _this.goal);
      params.append("view_user_id", _this.userid);

      axios({
        method: "post",
        url: _this.$store.state.api_url + "addUserGoal",
        data: params,
      })
        .then(function(response) {
          if (response.data.status > 0) {
            _this.$bvModal.hide("feelings_wrapper");
            _this.addUserGoalMsg = "Goal updated...";
            _this.$root.$emit("bv::toggle::collapse", "addGoalCollapse");
          } else {
            _this.addUserGoalMsg = "Error...";
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    addFeelings() {
      this.modal_type = "add";
      this.addUserGoalMsg = "";
      let _this = this;

      this.active_feeling = {};

      // Set unfinished feelingsLog from LocalStorage
      const feelingsLog = localStorage.getItem("feelingsLog");
      if (feelingsLog !== null) {
        const log = JSON.parse(feelingsLog);
        for (let key in log["feelings"]) {
          this.feelings[key] = log["feelings"][key];
        }
        for (let key in log["questions"]) {
          this.questions[key] = log["questions"][key];
        }
        this.date_selected = log.date_selected;
        this.validateForm(); // run validation to check can submit.
      } else {
        // resets feelings and questions to empty and 0.
        const feelings = Object.values(this.feelings);
        for (const key of feelings) {
          if (this.feelings[key.id]) {
            this.feelings[key.id].value = 0;
          }
        }
        const questions = Object.values(this.questions);
        for (const key of questions) {
          if (key.id === "goal") {
            this.questions["goal"].value = _this.goal_latest;
            this.questions["goal"].sanitised_value = _this.goal_latest;
          } else {
            this.questions[key.id].value = "";
            this.questions[key.id].sanitised_value = "";
          }
        }
        // reset date and disable submit button
        this.date = "";
        this.can_submit = false;
      }

      this.$bvModal.show("feelings_wrapper");

      // only after this allow for saveToLocalStorage to run.
      this.$nextTick(() => {
        this.opened_add_modal = true;
      });
    },

    replaceURLs(text) {
      if (!text) return;

      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, function(url) {
        var hyperlink = url;
        if (!hyperlink.match("^https?:\/\/")) {
          hyperlink = "http://" + hyperlink;
        }
        return (
          '<a href="' +
          hyperlink +
          '" style="color:#d6b674;" target="_blank" rel="noopener noreferrer">' +
          url +
          "</a>"
        );
      });
    },

    feelingsGet(type) {
      console.log("feelingsGet:");
      let _this = this;
      let params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("readonly", this.readonly);

      if (this.userid !== null) {
        params.append("user_id", this.userid);
      }

      params.append("category", "user_feelings_log");

      params.append("limit", this.limit);
      params.append("order_by", "access");
      params.append("order_direction", "desc");
      params.append("type", "edit");

      if (type == "search") {
        params.append("search_text", _this.search_text);
      }

      this.history = [];
      this.search_text = "";
      this.searching = 1;

      axios({
        url: _this.$store.state.api_url + "feelingsGet",
        params: params,
      })
        .then(function(response) {
          if (response.data.feelings && response.data.feelings !== null) {
            let entries = Object.values(response.data.feelings);
            _this.history = entries;
          }
          if (response.data.goal) {
            _this.goal_latest = response.data.goal;
          }

          _this.feelings_total = response.data.total_feelings;
          _this.searching = 0;

          _this.$store.commit("profileActiveSet", response.data.profile);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /*membersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.membersGet(loading, search, this);
			}
		},
		membersGet(loading, search) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'team_members');
			axios({
				url: _this.$store.state.api_url + 'teamMembersSearch',
				params: params,
			})
				.then(function (response) {
					_this.share_members = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: membersGet.');
				});
		},*/

    mark_feeling_viewed(feeling) {
      feeling.has_new_comment = 0;
      let _this = this;
      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("forum_id", feeling.id);

      axios({
        method: "post",
        url: _this.$store.state.api_url + "forumRepliesViewed",
        data: params,
      })
        .then(function() {})
        .catch(function(error) {
          console.log(error);
        });
    },

    ObjectLength(object) {
      return Object.keys(object).length;
    },

    removeFeeling() {
      var c = confirm("Are you sure!");
      if (c === true) {
        let _this = this;

        let params = new URLSearchParams();
        params.append("token", _this.$store.state.session_id);
        params.append("forum_id", _this.active_feeling.id);

        axios({
          method: "post",
          url: _this.$store.state.api_url + "feelingsRemove",
          data: params,
        })
          .then(function() {
            _this.$bvModal.hide("feelings_wrapper");
            _this.feelingsGet("latest");
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },

    replyAdd() {
      console.log("replyAdd");
      let _this = this;

      _this.reply_text = this.replaceURLs(_this.reply_text);
      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("main_text", _this.reply_text);
      params.append("post_id", _this.active_feeling.id);
      params.append("view_user_id", _this.userid);

      axios({
        method: "post",
        url: _this.$store.state.api_url + "feelingsReply",
        data: params,
      })
        .then(function(response) {
          if (response.data.status == 1) {
            _this.$bvModal.hide("feelings_wrapper");
            _this.reply_text = "";
            _this.feelingsGet("latest");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    setBarWidth(val, id, bars) {
      var num = this.ObjectLength(bars);
      val = (val / num) * 100;
      var C = "width: " + val + "%;";
      return C;
    },

    setBarColour(val) {
      var C = "white_bgd";
      if (val > 7) {
        C = "gold_bgd";
      } else if (val > 4) {
        C = "cl_bg_blue"; //'silver_bgd';
      } else if (val > 0) {
        C = "bronze_bgd";
      }
      return C;
    },

    setColour(val) {
      var C = "bronze_bgd";
      if (this.feelings[val].value > 7) {
        C = "gold_bgd";
      } else if (this.feelings[val].value > 4) {
        C = "cl_bg_blue"; //'silver_bgd';
      } else if (this.feelings[val].value <= 0) {
        C = "light_silver_bgd";
      }
      return C;
    },
    setColour2(val) {
      var C = "bronze_bgd";
      if (val > 7) {
        C = "gold_bgd";
      } else if (val > 4) {
        C = "cl_bg_blue"; //'silver_bgd';
      } else if (val <= 0) {
        C = "light_silver_bgd";
      }
      return C;
    },

    shareData() {
      this.$bvModal.show("share_wrapper");
    },

    submit() {
      let _this = this;

      _this.can_submit = false;

      _this.message.icon = "fas fa-spinner fa-spin";

      let params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("date", this.date_selected);

      const feelings = Object.values(this.feelings);
      for (const key of feelings) {
        params.append("feelings[" + key.id + "]", key.value);
      }

      const questions = Object.values(this.questions);
      console.log(questions);

      for (const question of questions) {
        let value = question.sanitised_value;
        try {
          let obj = JSON.parse(question["value"]);
          obj["text"] = question["sanitised_value"];
          value = JSON.stringify(obj);
        } catch (error) {
          console.error(error);
        }
        params.append("questions[" + question.id + "]", value);
      }

      if (_this.modal_type == "edit") {
        params.append("forum_id", _this.active_feeling.id);
      }

      axios({
        method: "post",
        url: _this.$store.state.api_url + "feelingsAdd",
        data: params,
      })
        .then(function(response) {
          if (response.data.status === 1) {
            _this.message.text = "";
            _this.message.icon = "fas fa-check";
            _this.$bvModal.hide("feelings_wrapper");
            _this.cancel();
            _this.feelingsGet("latest");
            localStorage.removeItem("feelingsLog");
          } else {
            _this.message.text = response.data.message;
            _this.message.icon = "fas fa-times";
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    validateForm() {
      // can only submit if date_selected is not empty.
      if (this.date_selected == "") {
        this.can_submit = false;
        this.message.text = "Select a date above";
        this.message.class = "text-danger";
        this.message.icon = "fas fa-times";
      } else {
        this.can_submit = true;
        this.message.text = "";
        this.message.class = "";
        this.message.icon = "";
      }
      this.saveToLocalStorage();
    },

    viewFeeling(feeling) {
      if (feeling.has_new_comment == 1) {
        this.mark_feeling_viewed(feeling);
      }
      this.active_feeling = feeling;
      this.$bvModal.show("feelings_wrapper");
      this.modal_type = "edit";

      const feelings = Object.values(this.feelings);
      for (const key of feelings) {
        if (this.feelings[key.id]) {
          this.feelings[key.id].value = this.active_feeling.data.bars[key.id]
            ? this.active_feeling.data.bars[key.id]
            : 0;
        }
      }
      const questions = Object.values(this.questions);
      for (const key of questions) {
        if (this.questions[key.id]) {
          this.questions[key.id].value = this.active_feeling.data.questions[
            key.id
          ];
          this.questions[key.id].sanitised_value = ""; // overwrite sanitised_value back to ""
          /*if (key.id == 'goal') {
						this.goal = this.active_feeling.data.questions['goal'];
					}*/
        }
      }
      this.sanitiseQuestions();
      console.log(this.questions, "mounted");
      /* handle no goal set 
			if(this.active_feeling.data.questions['goal'] === undefined){
			this.goal = this.goal_latest;
			this.questions.goal.value = this.goal_latest;
			}*/

      this.date = this.active_feeling.date_edit;
    },

    yesNoText(val) {
      if (val == 0) return "No";
      else return "Yes";
    },

    saveToLocalStorage() {
      // save value to localStorage only if in add mode and after mountng.
      if (this.modal_type === "add" && this.opened_add_modal) {
        let log = {
          feelings: JSON.parse(JSON.stringify(this.feelings)),
          questions: JSON.parse(JSON.stringify(this.questions)),
          date_selected: this.date_selected,
        };
        localStorage.setItem("feelingsLog", JSON.stringify(log));
      }
    },

    cancel() {
      console.log("cancel");
      for (let key in this.questions) {
        this.questions[key]["sanitised_value"] = "";
      }
    },
  },
  watch: {
    date_selected() {
      this.validateForm();
    },
  },
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.gold_bar {
  background-color: #fff;
  color: #d1af60 !important;
  text-align: left;
}
.sleep_bar {
  background-color: #ccc;
}
.productivity_bar {
  background-color: #ccc;
}
.wellbeing_bar {
  background-color: #ccc;
}

.text-wrapper {
  word-wrap: break-word;
}
</style>
